<template>
  <main-layout v-if="banner">
    <template slot="header-title">{{banner.name}}</template>
    <template slot="header-actions">
      <common-button type="secondary">
        <router-link  class="text-gray-600" :to="{ name: 'BannerList', params: {site: site.sitekey } }">Cancel </router-link>
      </common-button>

      <common-button
        @click="save()">Save
      </common-button>
    </template>


    <template slot="main">

      <common-ui-form-general
      v-if="banner"
        type="banner"
        :bannerId="banner.id"
        :site="site"
        :code="banner.code"
        :name="banner.name"
        :status="banner.status"
        :activationdate="banner.activationdate"
        :deactivationdate="banner.deactivationdate"
        :csvFields="banner.csvFields"
        :importCsv="importCsv"
        :isCsv="banner.iscsv === 1"
        :loading="loading"
        @update-name="(name) => fields.name = name"
        @update-status="(status) => fields.status = status"
        @update-activationdate="(dateStart) => updateDateStart(dateStart)"
        @update-deactivationdate="(dateEnd) => updateDateEnd(dateEnd)" 
        @update-csv-import="(csvFile) => importCsv = csvFile"
        @upload-csv-file="uploadCsvFile"/>

      <sections-extra-layout>
        <template slot="title">Content</template>
        <template slot="description">Define what is printed on the banner.</template>
        <template slot="content">

          <div>
            <p class="font-bold mb-4">What is the title of banner content ?</p>
            <div class="mt-2">
              <label v-for="lang in (langs)" :key="lang" class=" cursor-pointer w-full mb-2 inline-flex items-center ml-6">
                <span class="ml-2">{{ lang }}</span>
                <input v-model="fields.title[lang]" @input="handleChangeContent('title', lang)" type="text" placeholder="Enter the title here..." class="mx-4 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
              </label>
            </div>
            <p class="font-bold mb-4">What is the type of banner content ?</p>
            <div class="mt-2">

              <label class="cursor-pointer mb-4 inline-flex items-center ml-6">
                <input v-model="fields.type" type="radio" class="form-radio" name="type" value="info">
                <span class="ml-2">Info</span>
              </label>

              <label class=" cursor-pointer mb-4 inline-flex items-center ml-6">
                <input v-model="fields.type" type="radio" class="form-radio" name="type" value="warning">
                <span class="ml-2">Warning</span>
              </label>

              <label class=" cursor-pointer mb-4 inline-flex items-center ml-6">
                <input v-model="fields.type" type="radio" class="form-radio" name="type" value="critical">
                <span class="ml-2">Critical</span>
              </label>
            </div>
          </div>

          <div class="mb-2">
            <p class="font-bold mb-4">What is the content of the banner?</p>
            <div class="mt-2">
              <label v-for="lang in (langs)" :key="lang" class=" cursor-pointer w-full mb-2 inline-flex items-center ml-6">
                <span class="ml-2">{{ lang }}</span>
                <input v-model="fields.content[lang]" @input="handleChangeContent('content', lang)" type="text" placeholder="Type the content here..." class="mx-4 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
              </label>
            </div>
          </div>

          <div class="mb-2">
            <p class="font-bold mb-4">What is the content of the link?</p>
            <div class="mt-2">
              <label v-for="lang in (langs)" :key="lang" class=" cursor-pointer w-full mb-2 inline-flex items-center ml-6">
                <span class="ml-2">{{ lang }}</span>
                <input v-model="fields.ctatext[lang]" @input="handleChangeContent('ctatext', lang)" type="text" placeholder="Type the content of the link here..." class="mx-4 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
              </label>
            </div>
          </div>

          <div class="mb-2">
            <p class="font-bold mb-4">What is the url of the link?</p>
            <p v-if="lock" class="-mt-4 mb-4">
              <span class="material-symbols-outlined align-middle text-base">
                info
              </span>
              The URL of the last step is locked because it is already filled in the imported csv
            </p>
            <div class="mt-2">
              <input v-model="fields.ctalink" :disabled="lock" type="text" placeholder="Enter the link here..." :class="{'text-gray-500': lock, 'text-gray-700': !lock, 'cursor-not-allowed': lock}" class="mx-4 px-3 py-3 placeholder-gray-400 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full">
            </div>
          </div>
          <label class="cursor-pointer mb-4 inline-flex items-center ml-6">
            <input v-model="fields.openinnewtab" type="checkbox" class="form-checkbox" name="openinnewtab">
            <span class="ml-2">Open in a new tab</span>
          </label>

          <common-import-fields v-if="banner.iscsv" v-bind:fields="banner.csvFields"/>

        </template>
      </sections-extra-layout>

      <common-ui-form-trigger
      v-if="banner"
      type="banner"
      :data="banner"
      @update-frequencylimitationvalue="(newfrequencylimitationvalue) => fields.frequencylimitationvalue = newfrequencylimitationvalue"
      @update-frequencylimitation="(newFrequencylimitation) => fields.frequencylimitation = newFrequencylimitation"
      @update-frequency="(newFrequency) => frequency = newFrequency"  />

      <common-ui-form-targeting
      v-if="banner"
      type="Banner"
      :current-url="banner.url"
      :target-url="banner.url_target"
      :target-url-list="banner.url_target_list"
        :exclude-url="banner.url_exclude_list"
        @update-fields-url="(url) => fields.url = url"
        @update-path-target="(urlTarget) => fields.url_target_list = urlTarget"
        @update-path-exclude="(urlExclude) => fields.url_exclude_list = urlExclude"
        />

        <common-ui-form-audience
        v-if="fields.target_audience && fields.bubbles"
        :key="refreshAudience"
        type="banner"
        :target-audience="fields.target_audience"
        :excluded-audience="fields.excluded_audience"
        :bubbles="fields.bubbles"
        :excluded-bubbles="fields.excluded_bubbles"
        :isCsv="banner.iscsv === 1"
        @update-audience="(audienceData) => fields.target_audience = audienceData"
        @update-excluded-audience="(audienceData) => fields.excluded_audience = audienceData"
        @update-bubbles="(bubble) => updateFieldsBubble(bubble)"
        @update-excluded-bubbles="(bubble) => updateFieldsExcludedBubble(bubble)"
        @erase-bubble="(bubbles) => fields.bubbles = bubbles"
        @erase-excluded-bubble="(bubbles) => fields.excluded_bubbles = bubbles"
        />

        <template>
          <div style="position: fixed; bottom: 20px; left: 20px; margin: 0; z-index: 9999;">
            <common-ui-alert
              type="warning"
              message="You have modification not saved. Don't forget to save it."
              :base="banner"
              :object="fields"
            />
          </div>
        </template>

        <modal-confirmation
        v-if="modals.isOpenDeletionConfirmation"
        :open="modals.isOpenDeletionConfirmation"
        type="danger"
        messageTitle="Warnings !"
        message="Do you really want to remove this banner ? This actions cannot be undone."
        messageAction="Yes, I'm sure !"
        @execute="remove"
        @close='modals.isOpenDeletionConfirmation = false' />
    </template>
  </main-layout>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import ModalConfirmation from '@/components/others/utils/ModalConfirmation.vue'

export default {
  name: 'BannerEdit',
  components: {
    ModalConfirmation
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      fields: {
        activationdate: null,
        bubbles: [],
        content: {},
        csvFields: [],
        ctalink: null,
        ctaonclick: null,
        ctatext: {},
        deactivationdate: null,
        excluded_audience: null,
        excluded_bubbles: [],
        frequencylimitation: null,
        frequencylimitationvalue: null,
        iscsv: 0,
        name: null,
        redirection_url: null,
        status: null,
        target_audience: null,
        title: {},
        type: null,
        url: null,
        url_exclude_list: [],
        url_target: null,
        url_target_list: [],
        openinnewtab: false,
      },

      modals: {
        isOpenDeletionConfirmation: false
      },

      frequency: null,
      bubblesClean: false,

      fieldsError: {
        url_target: null,
        url: null
      },

      inputs: {
        targetAll: false
      },

      lock: false,
      loading: false,
      importCsv: null,
      refreshAudience: false
    }
  },
  watch: {
    site: {
      handler: 'initBanner',
      immediate: true
    },
    'inputs.targetAll': function (value) {
      if (!this.loaded) { return false }

      if (!value) {
        this.fields.url_target = null
        this.fields.url_target_list = []
      } else {
        this.fields.url_target = '.*'
        this.fields.url_target_list = ['.*']
      }
    }
  },
  computed: {
    ...mapGetters('account', {
      sites: 'sites',
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('banners', {
      getById: 'getById'
    }),

    banner () {
      return this.getById(this.id)
    },

    langs () {
      let langs = []

      if (this.site) {
        this.site.languages.forEach((lang) => {
          langs.push(lang.lang)
        })
      }

      return langs
    }
  },
  methods: {
    ...mapActions('banners', ['loadBanner', 'updateBanner', 'removeBanner', 'updateCsvFile']),
    handleChangeContent (type, lang) {
      if (this.fields[type][lang].length === 0) {
        delete this.fields[type][lang];
      }
    },

    checkTrigger () {
      if (this.fields.frequencylimitation !== 'none' || this.fields.frequencylimitationvalue > 1) {
        this.frequency = 'sometimes'

        return true
      }

      this.frequency = 'everytime'
    },

    setFrequencyNever () {
      this.fields.frequencylimitation = 'none'
      this.fields.frequencylimitationvalue = 0
      this.frequency = 'never'
    },

    setFrequencyEver () {
      this.fields.frequencylimitation = 'none'
      this.fields.frequencylimitationvalue = 1
      this.frequency = 'everytime'
    },

    updateFieldsBubble (bubble) {
      const indexBubble = this.fields.bubbles.findIndex(b => b.id === bubble.id)
      const bubbleExist = indexBubble !== -1

      if (bubbleExist) { this.fields.bubbles.splice(indexBubble, 1) }

      this.fields.bubbles.push(bubble)
    },

    updateFieldsExcludedBubble (bubble) {
      const indexBubble = this.fields.excluded_bubbles.findIndex(b => b.id === bubble.id)
      const bubbleExist = indexBubble !== -1
      if (bubbleExist) { this.fields.excluded_bubbles.splice(indexBubble, 1) }

      this.fields.excluded_bubbles.push(bubble)
    },

    updateDateStart (ds) {
      this.fields.activationdate = ds
    },

    updateDateEnd (de) {
      this.fields.deactivationdate = de
    },

    checkInputs () {
      const ValidHostnameRegex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/

      let error = false

      if (!this.fields.name) {
        this.fieldsError.name = 'Name must be a valid string, like: Welcome dear !'
        error = true
      }

      if (!this.fields.url || !Array.isArray(this.fields.url.match(ValidHostnameRegex)) || (Array.isArray(this.fields.url.match(ValidHostnameRegex)) && !this.fields.url.match(ValidHostnameRegex).length)) {
        this.fieldsError.url = 'Hostname must be a valid string, like: rocketfid.com'
        error = true
      }

      if (!this.checkValidationDate) {
        this.fieldsError.date = 'Starting date need to start before ending date'
        error = true
      }

      if (this.checkValidationDate) {
        this.fieldsError.date = null
        error = false
      }

      return !error
    },

    save () {
      this.bubblesClean = true
      if (this.fields.target_audience === 'all') { this.fields.bubbles = [] }
      if (this.fields.excluded_audience === 'no-one') {
        this.fields.excluded_bubbles = []
      }
      this.langs.forEach((l) => {
        if (this.fields.title[l] === '') {
          delete this.fields.title[l]
        }
        if (this.fields.content[l] === '') {
          delete this.fields.content[l]
        }
      })
      this.checkLinkText()
      this.updateBanner({
        banner: {...this.fields, id: this.id},
        sitekey: this.$route.params.site
      }).then((banner) => {
        this.updateFields(banner)
        this.pendingStep = false
        this.$notify({title: 'Success', message: 'Banner updated with success'})
      }).catch(() => {
        this.$notify.error({title: 'Error', message: 'An error has occured'})
      })
    },

    remove () {
      this.removeBanner({ banner: {id: this.id} })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.banner.deleted'),
            type: 'success'
          })
          this.$router.push(`/${this.site.sitekey}/banners/`)
          console.log('BANNER REMOVED')
        })
        .catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.data.code + '.title'),
            message: this.$root.$t('api.' + response.data.code + '.message')
          })
        })
    },

    initBanner () {
      if (this.site) {
        // 1. Load the banner
        this.loadBanner({id: this.id})
          .catch(() => {
            this.$notify.error({title: 'Error', message: 'An error has occured'})
          }).then((banner) => {
            this.updateFields(banner)
          })
      }
    },
    checkLinkText () {
      const ctaText = this.fields.ctatext.__ob__.value
      if (ctaText.en === '' && ctaText.fr === '') {
        this.fields.ctatext = {}
      } else if (ctaText.en === '' && ctaText.fr !== '') {
        delete ctaText.en
      } else if (ctaText.fr === '' && ctaText.en !== '') {
        delete ctaText.fr
      } else {
      }
    },
    updateFields (banner) {
      if (this.fields.url_target !== '.*' || this.fields.url_target_list === ['.*']) {
        this.fields.target_audience = null
      }
      this.fields = Object.assign({}, banner)
      this.fields.ctatext = (banner.ctatext && typeof banner.ctatext === 'object' && !Array.isArray(banner.ctatext)) ? Object.assign({}, banner.ctatext) : {}
      this.fields.content = (banner.content && typeof banner.content === 'object' && !Array.isArray(banner.content)) ? Object.assign({}, banner.content) : {}
      this.fields.title = (banner.title && typeof banner.title === 'object' && !Array.isArray(banner.title)) ? Object.assign({}, banner.title) : {}

      if (this.fields.frequencylimitation === 'none' && this.fields.frequencylimitationvalue === 0) {
        this.frequency = 'never'
      } else if (this.fields.frequencylimitation === 'none' && this.fields.frequencylimitationvalue === 1) {
        this.frequency = 'everytime'
      } else {
        this.frequency = 'sometimes'
      }

      if (this.fields.csvFields.includes("last_step_url")) {
        this.fields.ctalink = "[[last_step_url]]"
        this.lock = true
      }

      this.fields.iscsv = banner.iscsv;

      setTimeout(() => {
        this.loaded = true
      }, 500)
    },

    async uploadCsvFile() {
      if(this.importCsv) {
        this.loading = true
        /** upload csv file */
        let banner = await this.updateCsvFile({
          banner: {...this.fields, id: this.id},
          csvFile: this.importCsv,
          sitekey: this.$route.params.site
        }).catch((response) => {
          let message = response.response && response.response.data && response.response.data.error ? response.response.data.error : "An error occurred while importing the csv file"
          this.$notify({
            title: "Error",
            message: message,
            type: "error"
          });
          this.importCsv = null
          this.loading = false
          throw response;
        })
        this.importCsv = null
        /** force audience component to re-render */
        this.refreshAudience = !this.refreshAudience
        /** update fields */
        this.updateFields(banner)
      }
      this.loading = false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isSameObject(this.fields, this.banner) && this.bubblesClean) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Banner/BannerEdit.vue